module.exports = "<div class=\"loading-screen-wrapper\" *ngIf=\"loading\">\n  <div class=\"loading-screen-icon\">\n    <h3>處理中</h3>\n  </div>\n</div>\n"